import enterView from 'enter-view';
import {
  API_KEY,
  MAP_STYLES,
  MAP_MARKER_URL,
  MAP_MARKER_ACTIVE_ICON,
} from '../constants/maps';

document.addEventListener('alpine:init', () => {
  Alpine.data('staticMap', (input) => {
    return {
      init() {
        const { locations, zoom } = input;

        if (!locations) {
          return {};
        }

        const markers = this._getLocationsQueryString(
          locations,
          `color:0x${MAP_MARKER_ACTIVE_ICON.fillColor.substr(1, 6)}FF|`,
        );

        const styles = this._getStyleQueryString();

        const url = this._generateURL(zoom, markers, styles);

        let alt = '';

        locations.forEach((location) => {
          alt += `${location.description} `;
        });

        enterView({
          selector: [this.$el],
          enter: () => {
            this._createMapImg(url, alt);
          },
          once: true,
        });
      },
      _getLocationsQueryString(l, markerStyle) {
        let markers = markerStyle ?? `anchor:14,50|icon:${MAP_MARKER_URL}|`;

        l.forEach((location) => {
          markers += `${location.center.lat},${location.center.lng}|`;
        });

        return markers;
      },
      _getStyleQueryString() {
        let styleString = '';

        MAP_STYLES.forEach((style) => {
          styleString += `&style=feature:${style.featureType}|element:${style.elementType}|`;

          style.stylers.forEach((item) => {
            const key = Object.keys(item);
            let val = item[key];

            if (key[0] === 'color') {
              val = `0x${val.substr(1, 6)}FF`;
            }
            styleString += `${key[0]}:${val}|`;
          });
        });

        return styleString;
      },
      _generateURL(zoom, markers, styles) {
        return `https://maps.googleapis.com/maps/api/staticmap?key=${API_KEY}&zoom=${
          zoom || 6
        }&scale=2&size=640x360&markers=${encodeURI(markers)}${encodeURI(styles)}`;
      },
      _createMapImg(url, alt) {
        const img = document.createElement('img');

        img.src = url;
        img.classList.add('u-object-fit');
        img.alt = alt;

        this.$el.appendChild(img);
      }
    }
  });
});

